<mat-card appearance="outlined" fxFlex>
  <mat-card-header fxLayout="row">
    <div fxFlex></div>
  </mat-card-header>
  <mat-card-content>
    @if (isLoading) {
    <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
    }

    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
      <!-- Profile Field Configuration Section -->
      <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
        <mat-card-title>Profile Field Configuration</mat-card-title>
        <p class="section-description">
          Configure which profile fields are visible and required for users associated with this advertiser.
        </p>

        <form [formGroup]="profileConfigForm" fxLayout="column wrap">

          <table mat-table [dataSource]="profileFields" class="profile-fields-table">

            <!-- Field Name Column -->
            <ng-container matColumnDef="fieldName">
              <th mat-header-cell *matHeaderCellDef>Field title</th>
              <td mat-cell *matCellDef="let field" [class.sub-field]="field.isSubField">
                <div class="field-name-cell">
                  <div class="field-title" [class.sub-field-title]="field.isSubField">
                    @if (field.isSubField) {
                    <span class="sub-field-indent"></span>
                    }
                    {{ field.displayName }}
                  </div>
                  @if (field.description) {
                  <div class="field-description">{{ field.description }}</div>
                  }
                  @if (field.showCurrentFormat) {
                  <div class="current-format">
                    <span class="format-label">Current format: </span>
                    <span class="format-value">{{ getCurrentDateFormatLabel() }}</span>
                  </div>
                  }
                  @if (field.hasFormat) {
                  <div class="field-format">
                    <mat-form-field appearance="outline" class="compact-select">
                      <mat-select [formControlName]="field.formatControlName"
                        [disabled]="!profileConfigForm.get(field.visibleControlName)?.value">
                        @for (format of dateFormats; track format) {
                        <mat-option [value]="format.value">
                          {{ format.label }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  }
                </div>
              </td>
            </ng-container>

            <!-- Enabled Column -->
            <ng-container matColumnDef="enabled">
              <th mat-header-cell *matHeaderCellDef>Visible</th>
              <td mat-cell *matCellDef="let field">
                <mat-slide-toggle [formControlName]="field.visibleControlName"
                  [disabled]="field.isSubField && !profileConfigForm.get('dateOfBirthVisible')?.value" color="primary">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Required Column -->
            <ng-container matColumnDef="required">
              <th mat-header-cell *matHeaderCellDef>Required</th>
              <td mat-cell *matCellDef="let field">
                <mat-checkbox [formControlName]="field.requiredControlName" color="primary">
                </mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['fieldName', 'enabled', 'required']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['fieldName', 'enabled', 'required'];"
              [class.main-field-row]="!row.isSubField" [class.sub-field-row]="row.isSubField"></tr>
          </table>

        </form>
      </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
      <lib-button color="primary"
        *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
        [disabled]="profileConfigForm.invalid || isSaving" (buttonClick)="onSave()">
        @if (!isSaving) {
        <span>Save Configuration</span>
        }
        @else {
        <mat-spinner diameter="16" style="margin-right: 8px;"></mat-spinner>
        <span>Saving...</span>
        }
      </lib-button>
      <lib-button color="warn" [disabled]="isSaving" (buttonClick)="onReset()">
        Reset to defaults
      </lib-button>
    </div>

  </mat-card-content>
</mat-card>